// Copyright ©️ 2026 eVolve MEP, LLC

import { type ReactNode, useLayoutEffect, useState } from 'react';

import type { StrongOmit } from '@evolvemep/api-ts';
import type { BrowserHistory } from 'history';
import { Router, type RouterProps } from 'react-router';

export const BrowserRouter = ({
  history,
  children,
  ...props
}: {
  history: BrowserHistory;
  children: ReactNode;
} & StrongOmit<RouterProps, 'location' | 'navigationType' | 'navigator'>) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router {...props} location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  );
};
